import React, { useState, useEffect, useRef } from 'react';

const stats = [
  { stop: 25,   suffix: '+', label: 'Years Experience',    icon: 'fas fa-award' },
  { stop: 340,  suffix: '+', label: 'Luxury Rooms',        icon: 'fas fa-bed' },
  { stop: 18500,suffix: '+', label: 'Happy Guests',        icon: 'fas fa-face-smile' },
  { stop: 48,   suffix: '',  label: 'Award Winning',       icon: 'fas fa-trophy' },
];

function Counter({ stop, suffix, label, icon }) {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setStarted(true); obs.disconnect(); } },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!started) return;
    let cur = 0;
    const duration = 2200;
    const steps = 60;
    const increment = stop / steps;
    const interval = duration / steps;
    const timer = setInterval(() => {
      cur += increment;
      if (cur >= stop) { setCount(stop); clearInterval(timer); }
      else setCount(Math.floor(cur));
    }, interval);
    return () => clearInterval(timer);
  }, [started, stop]);

  return (
    <div className="counter-block col-lg-3 col-sm-6" ref={ref}>
      <div className="counter-inner">
        <div className="counter-icon">
          <i className={icon}></i>
        </div>
        <div className="counter-number">
          <span className="count-num">{count.toLocaleString()}</span>
          <span className="count-suffix">{suffix}</span>
        </div>
        <div className="counter-label">{label}</div>
      </div>
    </div>
  );
}

export default function CounterSection() {
  return (
    <section className="counter-section">
      <div className="counter-bg"></div>
      <div className="auto-container">
        <div className="row">
          {stats.map((s, i) => (
            <Counter key={i} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}
